import { render, staticRenderFns } from "./AttachedDocuments.vue?vue&type=template&id=4bf93b23"
import script from "./AttachedDocuments.vue?vue&type=script&lang=js"
export * from "./AttachedDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports